<template>
    <div class="step2-container">
        <div @scroll="scrollToEnd" class="main-content-container no-scrollbar">
            <div class="content-container">
                <ul v-if="!addonProducts || addonProducts.length == 0" class="products-container no-scrollbar">
                    <li v-for="n in 12" :key="n">
                        <AddonProductSkeleton v-for="n in 12" :key="n" />
                    </li>
                </ul>
                <ul v-else class="products-container no-scrollbar">
                    <p class="other-gifts" v-if="nonFilteredProducts.length > 0">{{breadcrumbText}}</p>
                    <li v-for="addonProduct in sortedProducts" :key="addonProduct.id">
                        <AddonProductNew @loadmodal="openModal($event)" :product="addonProduct" :cartProducts="selectedAddonProducts" :addCopy="addCopy"/>
                    </li>
                    <p class="other-gifts" v-if="nonFilteredProducts.length > 0">All Other Gifts</p>
                    <li v-for="addonProduct in nonFilteredProducts" :key="addonProduct.id">
                        <AddonProductNew @loadmodal="openModal($event)" :product="addonProduct" :cartProducts="selectedAddonProducts" :addCopy="addCopy"> </AddonProductNew>
                    </li>
                </ul>
            </div>
        </div>
        <SideCartMobile v-if="selectedAddonProducts.length > 0" @openmodal="openModal($event)" @changepage="changePage($event)" :cartProducts="selectedAddonProducts"/>
        <AddonProductModalMobile 
            :showModal="showModal"
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        />
        <BrandableProductModal 
            v-if="showBrandableModal == true && currentSelectedAddon != null" 
            :selectedAddon="currentSelectedAddon"
            :addonProducts="modalProducts"
            :cartProducts="selectedAddonProducts"
            :recommendedProducts="modalRecommendedProducts"
            @closemodal="closeModal()"
            @changeselectedaddon="openModal($event)"
        />
        <FiltersMobile @goall="goAll" :isSticking="isSticking" :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
        <SortMobile @closefilter="showSort()" :isSticking="isSticking" v-if="sortIsShown"/>
    </div>
</template>
    
<script>
import AddonProductNew from '../AddonProductNew.vue';
import SideCartMobile from './SideCartMobile.vue'
import AddonProductModalMobile from './AddonProductModalMobile.vue'
import FiltersMobile from './FiltersMobile.vue'
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
import BrandableProductModal from '../AddonProductModal.vue'
import SortMobile from './SortMobile.vue'
import confetti from "canvas-confetti";
import { AutoPlay, Arrow } from "@egjs/flicking-plugins";
import AddonProductSkeleton from "../Skeletons/AddonProductSkeleton.vue"

export default {
    mixins: [smoothReflow],
    components: {
        AddonProductNew,
        SideCartMobile,
        AddonProductModalMobile,
        FiltersMobile,
        BrandableProductModal,
        SortMobile,
        AddonProductSkeleton
    },
    watch:{
        cartLength:{
            handler(val,oldVal){
                if(val > oldVal && oldVal < 5){
                    confetti({origin:{
                        x: this.x
                        ,y: this.y
                    }});
                }
            }
        },
        selectedCategories:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedFilters:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedOccasion:{ 
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
        selectedSort:{
            handler(newVal){
                this.scrollHeader();
            },
            deep: true
        },
    },
    data() {
        return{
            selectedAddon: null,
            showModal: false,
            showBrandableModal: false,
            isAllItems: false,
            filterIsShown: false,
            isSticking: false,
            selectedSecondOccasion: null,
            sortIsShown: false,
            x: 0,
            y: 0,
            isOpenModal: false,
            bulkOpen: true,
            plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
        }
    },
    computed: {
        ...mapGetters([
            'addonProducts',
            'selectedAddonProducts',
            'categories',
            'occasions',
            'boxQty',
            'maxCapacity',
            'currentCapacity',
            'selectedSort',
            'rangePrice',
            'selectedCategories',
            'selectedFilters',
            'boxQty',
            'addCopy',
            'productLimit',
            'isPage'
        ]),
        selectedOccasion: {
            get(){ return this.$store.state.selectedOccasion},
            set(value){this.$store.commit('setSelectedOccasion', value )}
        },
        selectedOccasionMobile: {
            get(){ return this.$store.state.selectedOccasionMobile},
            set(value){this.$store.commit('setSelectedOccasionMobile', value )}
        },
        cartLength(){
            return this.selectedAddonProducts.length;
        },
        totalCurrentFilters(){
            let total = this.selectedOccasion.length + this.selectedCategories.filter(x => x != 'View All').length + this.selectedFilters.length;
            return total
        },
        breadcrumbText(){
            if(this.showReco)
                return `All products`
            let text = "";
            if(this.selectedOccasion.length > 0)
                text += this.selectedOccasion.join(", ");
            else 
                text += "All products";

            if(!this.selectedCategories.includes("View All"))
                text += ` > ${this.selectedCategories.join(", ")}`
            return text;
        },
        showReco(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 && this.selectedCategories.includes("View All") && this.selectedSort == 1;
        },
        notFilter(){
            return this.selectedOccasion.length == 0 && this.selectedFilters.length == 0 &&  this.selectedCategories.includes("View All") && this.selectedSort == 1;
        },
        recoProducts(){
            let products = this.addonProducts.filter(x => x.tags.some(y => y.toLowerCase() == "builder_reco"))

            return products
        },
        filteredPreProducts(){
            let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
            //filter via occasion
            if(this.selectedOccasion.length > 0){
                filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
            }

            //Filter categories
            if(!this.selectedCategories.includes("View All"))
                filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

            //remove brandable if sorting by inventory
            if(this.selectedSort == 6){
                filterAddons = filterAddons.filter(x => x.tags.every(y =>  !y.includes("Brandable Swag")));  
            }

            //Filter for each category
            for(let filter of this.selectedFilters){
                filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
            }

            //Exclude products
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
            }
            
            return filterAddons;
        },
        filteredProducts(){
            //Filter Price
            return this.filteredPreProducts.filter(x => ((x.variants[0].price-this.rangePrice.min)*(x.variants[0].price-this.rangePrice.max) <= 0));
        },
        nonFilteredProducts(){
            let ids = this.filteredProducts.map(x => x.id);
            let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
            if(excludeFilters.length > 0){
                let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                return this.addonProducts.filter(x => !ids.includes(x.id) && !excludedTags.includes(x.id));
            }
            return this.addonProducts.filter(x => !ids.includes(x.id));
        },
        sortedProducts(){
            var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
            switch(this.selectedSort){
                case "2":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = a.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        var bIsIncluded = b.tags.some(x => x.includes("Filter_Badges_Best Sellers"));
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    });
                    break
                case "3":
                    sortedProducts.sort((a,b) => {
                        var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
                        var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
                        if(aIsIncluded == bIsIncluded){
                            return 0;
                        }
                        else if(aIsIncluded == true){
                            return -1;
                        }
                        else if(bIsIncluded == true){
                            return 1;
                        }
                    })
                    break
                case "4":
                    sortedProducts.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
                    break;
                case "5":
                    sortedProducts.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
                    break;
                case "6":
                    sortedProducts.sort((a,b) => { 
                        return b.variants[0].true_inv - a.variants[0].true_inv;
                    });
                    break;
                default:
                    break;
            }

            //Filter onDemand Product
            sortedProducts = sortedProducts.filter((x) => {
                let inCart = this.selectedAddonProducts.find(y => y.id == x.id );
                if(inCart)
                    return true;
                let indexVariant =  x.variants.findIndex(x => x.sku && x.sku.toLowerCase().includes("ondemand"));
                if(indexVariant > -1){
                    if(this.boxQty >= this.demandQtyMin(x)){
                        return true
                    }
                    else {
                        let indexNotDemand =  x.variants.findIndex(x => !x.sku.toLowerCase().includes("ondemand"));
                        return x.variants[indexNotDemand].inventory_quantity >= this.boxQty
                    }
                }

                return x.variants.some(y => y.inventory_quantity >= this.boxQty);
            })

            return sortedProducts;
        },
        currentSelectedAddon(){
            if(this.selectedAddon){
                return this.selectedAddon;
            }
            else
                return null
        },
        modalProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id)
            return this.sortedProducts.filter(x => 
                ((this.maxCapacity > (this.currentCapacity + x.capacity)) 
                && (this.boxQty < x.variants[0].inventory_quantity))
                || addonCartIds.includes(x.id)
            )
        },
        modalRecommendedProducts(){
            var addonCartIds = this.selectedAddonProducts.map(x => x.id);
            if(this.filteredPreProducts.length > 0){
                let products = this.filteredPreProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")));
                if(products.length > 0)
                    return products.sort((a,b) => a.capacity - b.capacity);
                
                return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity);
            }
        },
    },
    methods: {
        openModal(product){
            gtag('event', 'open_modal', {
                location: 'build-a-box',
                label: product.title
            });
            this.selectedAddon = product;
            var isBrandable = this.selectedAddon.tags.filter(y => y.includes("Brandable Swag"));
            let designable = this.selectedAddon.tags.filter(y => y.includes("Designable"));
            if(isBrandable && isBrandable.length > 0 && (this.selectedAddon.variants.length > 1 || (designable && designable.length > 0))){
                this.showBrandableModal = true
            }
            else
                this.showModal = true;
        },
        showSort(){
            this.sortIsShown = !this.sortIsShown;
        },
        closeModal(){
            this.showModal = false;
            this.showBrandableModal = false;
            //this.selectedAddon = null;
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        showFilters(){
            this.filterIsShown = !this.filterIsShown;
        },
        goAll(){
            const pageContainer = document.getElementById('PageContainer');
            if (pageContainer) pageContainer.scrollTop = 0;
        },
        scrollToEnd({ target: { scrollTop, clientHeight, scrollHeight }}) {
            if (scrollTop + clientHeight >= scrollHeight && (this.isAllItems == true || this.selectedOccasion == "View All")) {
                gtag('event', 'end_scroll', {
                    location: 'build-a-box',
                    label: 'End Scroll'
                });
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        scrollToTop(){
            var myDiv = document.getElementById('scroll-container');
            myDiv.scrollTop = 0;
        },
        setSelectedOccasion(value){
            this.selectedOccasion = value;
            this.selectedOccasionMobile = value;
        },
        onMouseMove(e){
            this.x = e.touches[0].clientX / window.innerWidth;
            this.y = e.touches[0].clientY / window.innerHeight;
        },
        isMobile() {
            return this.windowWidth < 768;
        },
        scrollHeader(){
            let container = document.getElementById("scroll-container");
            this.$nextTick(() => {
                container.scrollIntoView();
            })
        },
    },
    mounted(){
        window.addEventListener('touchstart', this.onMouseMove, false);
        var that = this;
        var element = document.getElementById("header-container");
        var observer = new IntersectionObserver(function(entries) {
            if(entries[0].intersectionRatio < 1){
                setTimeout(function(){
                    that.isSticking = true;
                }, 200);
            }
            else{
                setTimeout(function(){
                    that.isSticking = false;
                }, 200);
            }
        }, { threshold: [0,1] });

        observer.observe(element);
    }
}
</script>

<style>
@media screen and (max-width: 767px){
    .offset-by-notification-bar{
        position: initial !important;
    }

    #PageContainer{
        width: 100%;
        font-size: 0;
        overflow-y: scroll;
        height: 100vh;
    }
}
</style>

<style scoped>

.step2-container{
    width: 100%;
    height: 100%;
    display: flex;
}

.main-content-container{
    min-width: 90%;
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.products-count-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2% 5%;
}

.products-count-container p{
    font-size: 3vw;
}

.products-count-container button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1% 5%;
    background-color: #FFFFFF;
    border: 1px solid #0F0C38;
    border-radius: 100px;
    color:#0F0C38;
    font-size: 3vw;
}

.main-content-container .content-container{
    width: 100%;
    display: flex;
    flex-direction: column;
}

.main-content-container .header-container{
    width: 100%;
    position: sticky;
    top: -1px;
    background-color: white;
    z-index: 3;
}

.main-content-container .header-container .floating{
    position: absolute;
    top: -60%;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.main-content-container .header-container .floating p{
    font-size: 3.5vw;
    font-family: Palmer Lake Print;
    line-height: 1;
}

.main-content-container .header-container.sticky{
    padding-top: 1px;
    background-color: #eaf2ff;
}

.main-content-container .header-container.sticky .buttons-container{
    background-color: #eaf2ff;
}

.categories-container{
    flex: 4;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 2% 0%;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 2.5vw;
    line-height: 1.3;
    color: #7A7991;
    padding: 2%;
    border-radius: 20px;
    border: 1px solid lightgray;
}

.categories-container button.selected{
    color: white;
    background-color: #0F0C38;
}
.products-container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    overflow-y: scroll;
    margin: 0;
    padding: 0 5% 5%;
}

.products-container li{
    width: 50%;
    display: inline-block;
    padding: 0% 2.5%;
    flex-shrink: 0;
    margin-bottom: 2rem;
}

.category-products-container .products-container li{
    width: 70%;
}

.recommended-product-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    overflow-y: scroll;
}

.recommended-category{
    font-family: Moret;
    font-size: 2rem;
    color: #0F0C38;
    line-height: 1.23;
    padding: 2% 0%;
}

.category-products-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5%;
}

.category-products-container .products-container{
    width: 100%;
    padding: unset;
    margin: 0;
    white-space: nowrap;
    flex-wrap: nowrap;
}

.shop-all{
    background-color: #ffd45f;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    padding: 0.5rem 1rem;
    font-family: 'Karla';
    font-weight: 700;
    font-size: 1rem;
    line-height: 150%;
    display: flex;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #0F0C38;
}

.shop-all:hover{
    background-color: #F6BC41;
}

.view-all-products-container{
    width: 100%;
    height: 76%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #FFF1F2;
    border: 1px dashed #0F0C38;
    box-sizing: border-box;
    text-align: center;
}

.other-gifts{
    width: 100%;
    border-bottom: 0.5px solid gray;
    font-family: Karla, sans-serif;
    text-transform: capitalize;
    margin-bottom: 1rem;
    font-size: 4vw; 
    font-weight: bold;
}

.other-gifts.recommended{
    margin-left: 3%;
    width: 97%;
}

.filter-categories-container{
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0% 2%;
    box-shadow: 0 1px #0003;
}

.filter-categories-container .title{
    flex: 2;
    font-size: 3vw;
    display: flex;
    gap: 5px;
    font-weight: bold;
    align-items: center;
}

.filter-categories-container .title img{
    width: 15px;
}

.filter-categories-container .white{
    font-size: 3vw;
    flex: 2;
    padding: 0.5%;
}


.title-container{
    width: 100%;
    position: absolute;
    top: 0%;
    right: 0%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
}

.title-container .title{
    line-height: 1;
    font-family: Founders Grotesk,sans-serif;
    font-weight: 300;
    color: white;
    font-size: 18vw;
    text-align: left;
}

.title-container .title span{
    font-style: italic;
    color: #fff;
    font-weight: 300;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
}

.title-container .legend{
    color: #c3ff01;
    font-size: 8vw;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
    font-style: italic;
    line-height: 1;
    margin-bottom: 1rem;
}

.title-container .happybox-button{
    width: 60%;
    margin-bottom: 1rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.title-container .instructions div{
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 7vw;
    max-width: 50%;
}

.title-container .instructions .first img{
    max-width: 40%;
}

.title-container .instructions div p{
    font-size: 2vw;
    line-height: 1.2;
    font-weight: bold;
}

.sticky-image-container{
    width: 100%;
    flex-direction: column;
    align-items: center;
    display: none;
}

.sticky .sticky-image-container{
display: flex;
}

.sticky-image-container .steps{
    width: 100%;
    font-size: 3vw;
    line-height: 1.5;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0;
}

.sticky-image-container .steps .dot span.selected{
    opacity: 1;
}

.header-container .buttons-container{
    display: flex;
    flex: 1;
    width: 100%;
    padding: 0% 3% 2%;
    position: sticky;
    top: 80px;
    background-color: white;
    z-index: 1;
    gap: 5px;
    justify-content: center;
}

.header-container.sticky .buttons-container .sort-block{
    display: none;
}

.header-container .buttons-container .sort-block{
    background-color: #ffebe0;
    border: 1px solid gray;
    font-size: 3vw;
    border-radius: 8px;
    text-align: center;
    padding: 0.5rem 1rem;
    position: absolute;
    right: 2%;
    top: -60%;
    line-height: 1.2;
}

.header-container .buttons-container .sort-block .close{
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    line-height: 1;
    border: 1px solid gray;
    aspect-ratio: 1;
    font-size: 0.8rem;
    width: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -.5rem;
    right: -.5rem;
}

.header-container .buttons-container .sort-block .arrow-t {
    width: 0;
    height: 0;
    border-top: 10px solid gray;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    position: absolute;
    bottom: -5px;
    left: -6px;
    transform: rotate(45deg);
}

.header-container .buttons-container .sort-block .arrow-t .inner {
    position: relative;
    top: -11px;
    right: 6px;
    width: 0;
    height: 0;
    border-top: 9.5px solid #ffebe0;
    border-right: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
}

.header-container .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    font-size: 3vw;
    padding: 1% 2.5%;
}

.header-container .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
}

.header-container .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
}

.header-container .buttons-container button img{
    width: 15px;
    padding: unset
}

.how-to .steps-container{
        width: 100%;
        display: flex;
        padding: 5% 0%;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
    }

     .how-to .step{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 80%;
        padding-bottom: 5%;
    }

     .how-to .step .circle-step{
        margin: unset;
        position: absolute;
        border-radius: 50%;
        border: 1px solid #0f0c38;
        width: 16%;
        background-color: #fcf6ef;
        aspect-ratio: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: moret;
        font-weight: 300;
        font-size: 25px;
    }

    .how-to .step .n-container{
        display: flex;
        width: 80%;
        gap: 15px;
    }

     .how-to .step p{
        line-height: 1.2;
        font-size: 3.5vw;
        margin: 0.5rem 0;
        text-align: left;
    }

    .how-to .step .number{
        width: 8vw;
        height: auto;
    }

    .how-to .step .main-image{
        width: 100%;
    }
    .how-to .step picture{
        width: 100%;
    }

    .second .main-image{
        padding: 0% 6%;
    }

    .how-to .second, .how-to .first{
        aspect-ratio: 1;
    }

    .how-to .first{
        z-index: 2;
    }

    .step-video{
        margin-top: 5%;
    }

     .step-video video{
        width: 95%;
        min-width: unset;
        margin: 5% 0;
    }

     .step-video .circle{
        position: absolute;
        width: 10%;
        top: -1%;
        left: 44.5%;  
    }

    .how-to button{
        width: 100%;
        padding: 2%;
        margin-bottom: 5%;
    }

    .how-to{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 10% 5%;
        background-color: #f7faff;
    }

    .how-to .how-wrapper{
        background-color: white;
        border-radius: 50px;
        box-shadow: 0 0 5px 1px #0000001F;
        padding: 5%;
    }

    .how-to .title{
        font-size: 6vw;
        line-height: 1.2;
        font-family: Karla, sans-serif;
        font-weight: bold;
        letter-spacing: -1px;
    }

    .content-header{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2% 10%;
        position: relative;
        scroll-margin: 70px;
        gap: 10px;
        margin-bottom: 2rem;
        border-top: 1px solid #C8CCD2;
        border-bottom: 1px solid #C8CCD2;
    }

    .content-header.cart{
        padding: 2% 0;
    }


    .content-header > div{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content-header .title{
        font-size: 7vw;
        line-height: 1;
        font-family: Founders Grotesk, sans-serif;
        margin: unset;
    }

    .content-header .subtitle{
        display: flex;
        font-size: 3.5vw;
        align-items: center;
        gap: 5px;
    }

    .content-header .starburst{
        width: 15%;
        transform: rotate(-10deg);
    }

    .flicking-container{
        margin-right: 1rem;
    }

    .recommended-flicker{
        width: 100%;
        background-color: #edf9eb;
        margin-bottom: 3rem;
        padding: 1rem 10% 0;
    }

    .flicker-wrapper{
        width: 100%;
        padding: 0% 2%;
    }
</style>